import React from 'react';
import { v4 as uuidV4 } from 'uuid';

import { MinimizeOrFullScreenButton } from '../../Loans/MinimizeOrFullScreenButton';

import { SearchResultsFor } from './SearchResultsFor';
import { SummaryInfoInput } from './SummaryInfoInput';

import { SUMMARY, AUTO, COMPARISON_SUMMARY_MAP } from '../../../constants/ComparisonSummary';

import './SearchSummary.css';

export const SearchSummary = ({
  financingType = AUTO,
  isLoading = false,
  checkRates = false,
  isFullScreen,
  setIsFullScreen,
  isEmailRatesSubmitted,
  signUpError,
  setIsEmailRatesSubmitted,
  handleEmailRates,
  user,
  ...otherProps
}) => {
  if (checkRates && isFullScreen) {
    return null;
  }
  return (
    <div className="search-summary-wrapper">
      <div className="search-summary">
        {SUMMARY}
        {!isFullScreen && checkRates && (
          <MinimizeOrFullScreenButton
            checkRates={checkRates}
            isFullScreen={isFullScreen}
            setIsFullScreen={setIsFullScreen}
          />
        )}
      </div>
      <div>
        <div className="summary-info-container-wrapper">
          {COMPARISON_SUMMARY_MAP[financingType].map((summaryInfoLabel) => {
            return (
              <SummaryInfoInput
                key={uuidV4()}
                content={otherProps[summaryInfoLabel] || summaryInfoLabel}
                isLoading={isLoading}
                summaryInfoLabel={summaryInfoLabel}
              />
            );
          })}
        </div>
        <SearchResultsFor
          financingType={financingType}
          isLoading={isLoading}
          isOnCalculatorPage={!!setIsFullScreen}
          handleEmailRates={handleEmailRates}
          isEmailRatesSubmitted={isEmailRatesSubmitted}
          signUpError={signUpError}
          setIsEmailRatesSubmitted={setIsEmailRatesSubmitted}
          user={user}
        />
      </div>
    </div>
  );
};
